import { callRestful } from './restful';
import { getConfig } from '../config/global';

export const callPost = (path: string, body: any, callback: (response: any) => void, error: (err: any) => void = () => {}) => {
    const config = getConfig();
    
    callRestful(
        `${config.apiServer}${path}`,
        'POST',
        {
            'Content-Type': 'application/json',
            'Referer': 'EIC-WEB'
        },
        body,
        callback,
        error,
    );
}

// const uploadFile = (path: string, file: any, callback: (response: any) => void): void => {
//     const config = getConfig();
//     const data = new FormData();
//     data.append('file', file);

//     callRestful(
//         `${config.apiServer}${path}`,
//         'POST',
//         {
//             'apikey': config.apiKey,
//             'apisecret': config.apiSecret,
//             'resourceOwnerID': config.resourceOwnerID,
//             'requestUID': config.requestUID,
//             'originalSystem': config.originalSystem,
//         },
//         data,
//         callback,
//         false
//     );
// }